import erroneousStsTableTemplate from './erroneousStatementsTable.html';
import { BackendService } from "../../../services/BackendService";
import {ERRONEOUS_STMTS} from '../../../services/arsweb/RoutingPaths';
import { erroneousStatementsCols, defaultSortModel } from './erroneousStatementsColDefs';
import { ERRONEOUS_STMTS_TITLE } from '../../../services/arsweb/TableTitles';
import {ReactTableController} from "../reactTableController";

/** @ngInject */
export function erroneousStatementsTable() {
    return {
        restrict: 'E',
        scope: {
            tableId: '@'
        },
        templateUrl: erroneousStsTableTemplate,
        controller: ErroneousStatementsTableController,
        controllerAs: 'vm'
    };
}

/** @ngInject */
export class ErroneousStatementsTableController extends ReactTableController {

    constructor($scope, userService, arsMainDependencies) {

        super($scope, userService, arsMainDependencies, null, new BackendService(userService), ERRONEOUS_STMTS,
            ERRONEOUS_STMTS_TITLE, 'erroneousStatementsTableParams', "pkey", false, [], defaultSortModel);
        this.isUserReport = false;
        this.backendService.service.config.params.filter = {};
        this.ftsMainDependencies.initCompletedPromise.then(() => this.initGrid(userService));
    }

    initGrid(userService) {

        userService.promise.then(()=> {
            // react account columns
            this.colDefs = erroneousStatementsCols(this.translate, userService);
			this.initCols();
            // react gridParameters for account table
            const statementsGridParams = {
                columnDefs: this.colDefs,
                url: this.backendService.service.getServiceUrl(ERRONEOUS_STMTS)
                };
            delete this.defaultReactGridParams.onReport;
            delete this.defaultReactGridParams.onSearchInputChange;
            this.reactGridParams = {...this.defaultReactGridParams, ...statementsGridParams};
        });
    }
}
